import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmptyURIValue, fixedEncodeURIComponent, URIPrefix } from '@sondermind/features/filter-form';
import { debounceTime, of } from 'rxjs';

@Component({
  selector: 'redirection-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './redirection-page.component.html',
  styleUrls: ['./redirection-page.component.scss'],
})
export class RedirectionPage implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {

  }

  ngOnInit(): void {
    this.checkQueryParams();
  }
  checkQueryParams() {
    this.route.queryParams
      .pipe(
        debounceTime(100),
      ).subscribe((queryParams) => {
        const stateVal = queryParams['state'] || EmptyURIValue;
        const insurance = queryParams['insurance']
          ? `${URIPrefix.INSURANCE}-${fixedEncodeURIComponent(queryParams['insurance'])}`
          : '';
        of(this.router.navigate([
          `${URIPrefix.STATE}-${stateVal}`,
          `${URIPrefix.CITY}-${EmptyURIValue}`,
          insurance
        ])).subscribe();
      });
  }
}
